let toastRef = null;

export const setToastRef = (ref) => {
  toastRef = ref;
};

export const showToast = ({
  severity,
  summary,
  detail,
  life = 3000,
  content,
}) => {
  toastRef && toastRef.show({ severity, summary, detail, life, content });
};
